import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AddEditPetModule } from '@molecules/add-edit-pet/add-edit-pet.module';
import { InfoGroupModule } from '@molecules/info-group/info-group.module';
import { SidebarInfocardModule } from '@molecules/sidebar-infocard/sidebar-infocard.module';
import { SharedModule } from '@shared/shared.module';

import { PetPolicyBreakdownComponent } from './pet-policy-breakdown/pet-policy-breakdown.component';
import { PolicyBreakdownComponent } from './policy-breakdown.component';

@NgModule({
	declarations: [PolicyBreakdownComponent, PetPolicyBreakdownComponent],
	imports: [
		CommonModule,
		RouterModule.forChild([]),
		SidebarInfocardModule,
		InfoGroupModule,
		SharedModule,
		AddEditPetModule,
	],
	exports: [PolicyBreakdownComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PolicyBreakdownModule { }
